<div *ngIf="isVideo">
  <video [id]="this.mediaType + this.playerSuffix" class="video-js vjs-default-skin vjs-big-play-centered"></video>
</div>
<div *ngIf="!isVideo" id="audioplayer">
  <div
    [id]="this.mediaType + this.playerSuffix"
    class="video-js vjs-default-skin"
    [ngClass]="isFullScreen ? 'fullscreen' : ''"
  ></div>

  <div class="audio-controller" [ngClass]="isFullScreen ? 'fullscreen' : ''">
    <span class="audio-ctrl play">
      <button id="playButton" class="play-button" (click)="togglePlay()">
        <img
          id="playButtonIcon"
          class="play-button-icon"
          src="{{ baseHref }}/assets/images/icon-audio-play.png"
          alt="Play Button"
        />
      </button>
    </span>
    <span class="audio-ctrl volume">
      <button id="volumeButton" class="volume-button" (click)="toggleMute()">
        <img
          [src]="isMuted ? '{{baseHref}}/assets/images/icon-mute.png' : '{{baseHref}}/assets/images/icon-audio.png'"
          class="volume-icon"
          id="volumeIcon"
        /></button
      ><input
        [disabled]="isMuted"
        id="volumeSlider"
        class="volume-slider"
        type="range"
        name="volume-slider"
        min="0"
        max="100"
        value="50"
        (change)="handleVolumeChange($event)"
      />
    </span>

    <span class="audio-ctrl timeline"
      ><span id="currentTime"> {{ currentTime }} </span>/
      <span id="totalDuration">
        {{ totalDuration }}
      </span>
    </span>

    <span class="audio-ctrl full-screen">
      <button id="fullScreenButton" class="full-screen-button" (click)="toggleFullScreen()">
        <img alt="" src="{{ baseHref }}/assets/images/icon-audio-full-screen.png" id="fullscreenbutton" />
      </button>
    </span>
    <span class="audio-ctrl new-tab">
      <button id="newTabButton" class="new-tab-button" (click)="openNewTab()">
        <img alt="" src="{{ baseHref }}/assets/images/icon-audio-new-tab.png" id="newtabbutton" />
      </button>
    </span>
    <span class="audio-ctrl download">
      <button id="downloadButton" class="download-button" (click)="download()">
        <img alt="" src="{{ baseHref }}/assets/images/icon-audio-download.png" id="downloadbutton" />
      </button>
    </span>
  </div>
</div>
